export const rafpNotFoundMessage =
  'Запрашиваемые сведения отсутствуют в РАФП, проверьте введенные значения. Если у данного иностранного ' +
  'юридического лица нет филиалов и представительств, зарегистрированных на территории РФ, ' +
  'то необходимо выбрать другой тип контролируемого лица – Иностранные юридические лица';
